"use client ";

import { Autoplay, Controller, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fragment, useState } from "react";
//
import { Button } from "@/components";
import { getImageURL, openLink, useSwiperSliderOptions, sanitizeHTML } from "@/lib";
import { useRouter } from "next/navigation";

export const HomePageProduct = ({
    data = {},
    slug = "product-application",
}) => {
    const { list, title } = data;

    const [activeTab, setActiveTab] = useState(0);
    const [firstSlider, setFirstSlider] = useState(null);
    const [secondSlider, setSecondSlider] = useState(null);

    const { nextSlide, prevSlide, options } = useSwiperSliderOptions({
        slidesPerView: "auto",
        noSwiping: false,
        onSwiper: setFirstSlider,
        controller: {
            control: secondSlider,
        },
        modules: [Controller],
        loop: true,
        noSwipingClass: "img_wrap",
    });

    const { options: secondSliderOptions } = useSwiperSliderOptions({
        slidesPerView: 2,
        initialSlide: 1,
        loop: true,
        modules: [Controller],
        onSwiper: setSecondSlider,
        controller: {
            control: firstSlider,
        },
        spaceBetween: "12px",
        breakpoints: {
            991: {
                slidesPerView: 1,
            },
            1200: {
                slidesPerView: 2,
            },
        },
    });

    return (
        <section className="product__section overflow-hidden" id={slug}>
            <div className="custom-container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-10 col-xl-8">
                        <div className="section_header">
                            <h4
                                className="heading fs-48 text-center fw-300"
                                dangerouslySetInnerHTML={{ __html: sanitizeHTML(title) }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="item__tab_wrapper">
                            {list?.map((item, index) => (
                                <Fragment key={index}>
                                    <a
                                        href={item?.link?.url}
                                        className={`item__tab ${
                                            activeTab === index ? "active" : ""
                                        }`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setActiveTab(index);
                                        }}
                                    >
                                        <h4
                                            className="heading fs-38"
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHTML(item?.title),
                                            }}
                                        />
                                        <div className="shape"></div>
                                    </a>

                                    {index === 0 && (
                                        <div className="item__img">
                                            <div className="outer_border"></div>
                                            <div className="inner_border"></div>
                                            <img
                                                className="img-fluid"
                                                src={getImageURL(
                                                    "/assets/images/home/product/item__circle_img.webp"
                                                )}
                                                alt=""
                                            />
                                        </div>
                                    )}
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="custom-container">
                <div className="item__tab_data tab-active">
                    <div className="row">
                        <div className="col-12 col-md-5 col-lg-4 col-xl-3">
                            <div className="product__data">
                                <h3
                                    className="h3 heading fs-36 fw-500"
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeHTML(list?.[activeTab]?.title),
                                    }}
                                />

                                <div className="content_wrap">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: sanitizeHTML(list?.[activeTab]?.description),
                                        }}
                                    />
                                </div>

                                <div className="btn-group">
                                    {Array.isArray(
                                        list?.[activeTab]?.buttons
                                    ) &&
                                        list?.[activeTab]?.buttons?.map(
                                            (itemButton, buttonIndex) => (
                                                <Button
                                                    key={buttonIndex}
                                                    label={
                                                        itemButton?.cta?.title
                                                    }
                                                    href={
                                                        itemButton?.cta?.url ||
                                                        "#"
                                                    }
                                                />
                                            )
                                        )}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-7 col-lg-8 col-xl-9">
                            <div className="product__slider_wrap row">
                                <div className="col-12 col-md-12 col-lg-7 col-xl-6">
                                    <div className="row">
                                        <div className="col-12 col-md-2 col-lg-2">
                                            <div className="slider__btn_col">
                                                <div className="slider__btn_wrapper">
                                                    <ul className="product__slider_btn">
                                                        <li className="prev-btn-product prev-btn-product">
                                                            <a
                                                                href="#!"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    prevSlide();
                                                                }}
                                                            >
                                                                <svg
                                                                    width={87}
                                                                    height={87}
                                                                    viewBox="0 0 87 87"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <rect
                                                                        x={-0.908046}
                                                                        y={0.908046}
                                                                        width={
                                                                            77.1839
                                                                        }
                                                                        height={
                                                                            77.1839
                                                                        }
                                                                        rx="38.592"
                                                                        transform="matrix(-1 0 0 1 81.1839 4)"
                                                                        stroke="#5B5B5B"
                                                                        strokeWidth={
                                                                            1.81609
                                                                        }
                                                                    />
                                                                    <path
                                                                        d="M61.207 43.0461C61.7085 43.0461 62.1151 43.4526 62.1151 43.9541C62.1151 44.4556 61.7085 44.8621 61.207 44.8621V43.9541V43.0461ZM25.1395 44.5962C24.7849 44.2416 24.7849 43.6666 25.1395 43.312L30.9183 37.5332C31.2729 37.1786 31.8478 37.1786 32.2025 37.5332C32.5571 37.8879 32.5571 38.4628 32.2025 38.8174L27.0658 43.9541L32.2025 49.0908C32.5571 49.4454 32.5571 50.0203 32.2025 50.375C31.8478 50.7296 31.2729 50.7296 30.9183 50.375L25.1395 44.5962ZM61.207 43.9541V44.8621H25.7816V43.9541V43.0461H61.207V43.9541Z"
                                                                        fill="#5B5B5B"
                                                                    />
                                                                </svg>
                                                            </a>
                                                        </li>

                                                        <li className="next-btn-product next-btn-product">
                                                            <a
                                                                href="#!"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    nextSlide();
                                                                }}
                                                            >
                                                                <svg
                                                                    width={87}
                                                                    height={87}
                                                                    viewBox="0 0 87 87"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <rect
                                                                        x={4.90805}
                                                                        y={4.90805}
                                                                        width={
                                                                            77.1839
                                                                        }
                                                                        height={
                                                                            77.1839
                                                                        }
                                                                        rx="38.592"
                                                                        stroke="#0DB02B"
                                                                        strokeWidth={
                                                                            1.81609
                                                                        }
                                                                    />
                                                                    <path
                                                                        d="M25.793 43.0461C25.2915 43.0461 24.8849 43.4526 24.8849 43.9541C24.8849 44.4556 25.2915 44.8621 25.793 44.8621V43.9541V43.0461ZM61.8605 44.5962C62.2151 44.2416 62.2151 43.6666 61.8605 43.312L56.0817 37.5332C55.7271 37.1786 55.1522 37.1786 54.7975 37.5332C54.4429 37.8879 54.4429 38.4628 54.7975 38.8174L59.9342 43.9541L54.7975 49.0908C54.4429 49.4454 54.4429 50.0203 54.7975 50.375C55.1522 50.7296 55.7271 50.7296 56.0817 50.375L61.8605 44.5962ZM25.793 43.9541V44.8621H61.2184V43.9541V43.0461H25.793V43.9541Z"
                                                                        fill="#0DB02B"
                                                                    />
                                                                </svg>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-10 col-lg-10 slider__left">
                                            <Swiper {...options}>
                                                {list?.[activeTab]?.list?.map(
                                                    (item, index) => (
                                                        <SwiperSlide
                                                            key={index}
                                                        >
                                                            <div
                                                                className={`product__slider_for product__slider_for_${
                                                                    index + 1
                                                                }`}
                                                            >
                                                                <RenderMainSlide
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                )}
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-4 col-lg-5 col-xl-6 slider__right">
                                    <div className="product__slider_sm">
                                        <Swiper {...secondSliderOptions}>
                                            {list?.[activeTab]?.list?.map(
                                                (item, index) => (
                                                    <SwiperSlide key={index}>
                                                        <div
                                                            className={`product__slider_nav product__slider_nav_${
                                                                index + 1
                                                            }`}
                                                        >
                                                            <div className="item__wrap">
                                                                <div className="single__item">
                                                                    <div className="img_wrap">
                                                                        <img
                                                                            className="img-fluid"
                                                                            src={getImageURL(
                                                                                item
                                                                                    ?.image
                                                                                    ?.src
                                                                            )}
                                                                            alt={
                                                                                item
                                                                                    ?.image
                                                                                    ?.alt
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="content_block text-center">
                                                                        <div className="content_head">
                                                                            <h3
                                                                                className="h3 heading fs-28 fw-500"
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: sanitizeHTML(item?.title),
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="content_wrap fw-500">
                                                                            <p
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: sanitizeHTML(item?.description),
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                )
                                            )}
                                        </Swiper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const RenderMainSlide = ({ item, index }) => {
    const { options: imagesSliderOptions } = useSwiperSliderOptions({
        slidesPerView: 1,
        modules: [EffectFade, Autoplay],
        autoplay: {
            delay: 1500,
            disableOnInteraction: false,
        },
        effect: "fade",
        nested: true,
        modules: [Autoplay, EffectFade],
    });

    const routes = useRouter();

    const OpenUrl = (url) => {
        if (url?.startsWith("http")) {
            window.open(url, "_blank");
        } else {
            routes.push(url);
        }
    };

    return (
        <div className="item__wrap">
            <div className="single__item">
                <Swiper {...imagesSliderOptions}>
                    {item?.images?.map((image, imageIndex) => (
                        <SwiperSlide key={imageIndex}>
                            <div className="img_wrap">
                                <div
                                    className={`product__img_slider product__img_slider_${
                                        index + 1
                                    }`}
                                >
                                    <img
                                        className={`img-fluid img-fluid-${
                                            index + 1
                                        }`}
                                        src={getImageURL(image?.image?.src)}
                                        alt={image?.image?.alt}
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="content_block text-center">
                    <div className="content_head">
                        <h3
                            className="h3 heading fs-36 fw-500 text-white"
                            dangerouslySetInnerHTML={{ __html: sanitizeHTML(item?.title) }}
                        />
                    </div>
                    <div className="content_wrap fw-500 text-white">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHTML(item?.description),
                            }}
                        />
                    </div>
                    <Button
                        label="Know More"
                        href={item?.link?.url || "#"}
                        onClick={(e) => {
                            e.preventDefault();
                            OpenUrl(item?.link?.url);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
